import { useState } from 'react'
import { Box, Select, Text, Grid, Button } from 'theme-ui'
import Counter from './Counter'
import PlusIcon from '../../icons/PlusFat'
import MinusIcon from '../../icons/MinusFat'

function FilterDate({
    day,
    month,
    year,
    icon,
    name,
    onChangeDay,
    onChangeMonth,
    onChangeYear,
    onClearBirthday,
}) {
    const [isOpen, setIsOpen] = useState(false)

    var days = Array.from(Array(31).keys()).map((d) => ({
        value: d + 1,
        label: d + 1,
    }))
    days.unshift({
        value: undefined,
        label: 'Day',
        disabled: true,
    })

    const years = [
        { value: undefined, label: 'Year', disabled: true },
        { value: 1989, label: '1989' },
        { value: 2009, label: '2009' },
        { value: 2010, label: '2010' },
        { value: 2011, label: '2011' },
        { value: 2012, label: '2012' },
        { value: 2013, label: '2013' },
        { value: 2014, label: '2014' },
    ]

    const months = [
        { value: undefined, label: 'Month', disabled: true },
        { value: 1, label: 'Jan' },
        { value: 2, label: 'Feb' },
        { value: 3, label: 'Mar' },
        { value: 4, label: 'Apr' },
        { value: 5, label: 'May' },
        { value: 6, label: 'Jun' },
        { value: 7, label: 'Jul' },
        { value: 8, label: 'Aug' },
        { value: 9, label: 'Sep' },
        { value: 10, label: 'Oct' },
        { value: 11, label: 'Nov' },
        { value: 12, label: 'Dec' },
    ]

    const selectedTotal = [day !== null, month !== null, year !== null].filter(
        Boolean
    )

    return (
        <>
            <Box
                sx={{
                    height: 52,
                    display: 'flex',
                    alignItems: 'center',
                    borderBottomColor: 'border',
                    borderBottomWidth: 1,
                    borderBottomStyle: 'solid',
                    cursor: 'pointer',
                }}
                onClick={() => setIsOpen(!isOpen)}
            >
                <Box
                    sx={{
                        mr: 2,
                        display: 'flex',
                    }}
                >
                    {icon}
                </Box>
                <Text
                    sx={{
                        fontSize: 1,
                        flex: 1,
                        textTransform: 'uppercase',
                    }}
                >
                    {name}
                </Text>
                {selectedTotal.length > 0 && (
                    <Counter total={selectedTotal.length} />
                )}
                {isOpen ? <MinusIcon /> : <PlusIcon />}
            </Box>

            {isOpen && (
                <Box
                    sx={{
                        borderBottomColor: 'border',
                        borderBottomWidth: 1,
                        borderBottomStyle: 'solid',
                        py: 3,
                    }}
                >
                    <Grid columns={3} gap={2}>
                        <CustomSelect onChange={onChangeDay}>
                            {days.map((d) => (
                                <option
                                    key={d.value}
                                    disabled={d.disabled}
                                    value={d.value}
                                    selected={d.value === day}
                                >
                                    {d.label}
                                </option>
                            ))}
                        </CustomSelect>
                        <CustomSelect onChange={onChangeMonth}>
                            {months.map((m) => (
                                <option
                                    key={m.value}
                                    disabled={m.disabled}
                                    value={m.value}
                                    selected={m.value === month}
                                >
                                    {m.label}
                                </option>
                            ))}
                        </CustomSelect>

                        <CustomSelect onChange={onChangeYear}>
                            {years.map((y) => (
                                <option
                                    key={y.value}
                                    disabled={y.disabled}
                                    value={y.value}
                                    selected={y.value === year}
                                >
                                    {y.label}
                                </option>
                            ))}
                        </CustomSelect>
                    </Grid>
                    {selectedTotal.length > 0 && (
                        <Button
                            sx={{
                                fontSize: [1, 1, 1],
                                py: [0, 0, 0],
                                px: [2, 2, 2],
                                display: 'flex',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                width: '100%',
                                mt: 3,
                                height: ['30px', '30px', '30px'],
                                lineHeight: ['30px', '30px', '30px'],
                            }}
                            onClick={onClearBirthday}
                        >
                            Clear
                        </Button>
                    )}
                </Box>
            )}
        </>
    )
}

function CustomSelect({ onChange, children }) {
    return (
        <Select
            arrow={
                <Box
                    as="svg"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="currentcolor"
                    sx={{
                        ml: -28,
                        alignSelf: 'center',
                        pointerEvents: 'none',
                    }}
                >
                    <path d="M7.41 7.84l4.59 4.58 4.59-4.58 1.41 1.41-6 6-6-6z" />
                </Box>
            }
            sx={{
                fontSize: 1,
            }}
            onChange={onChange}
        >
            {children}
        </Select>
    )
}

export default FilterDate
